import { v4 as uuid } from "uuid";
import {
  Button,
  createMuiTheme,
  MenuItem,
  MuiThemeProvider,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  deletePartida,
  getPartidaById,
  postPartida,
  updatePartida,
} from "../../../../api/partida";
import { getPartidaCategories } from "../../../../api/partidaCategory";
import { getProducts } from "../../../../api/product";
import { getProductFamilies } from "../../../../api/productFamily";
import { getProductTypes } from "../../../../api/productType";
import { getProductUnitTypes } from "../../../../api/productUnitType";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { PARTIDA_REFERENCE_MAX_LENGTH } from "../../../../utils/constants";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import ProductSelectTableDialog from "../../../components/dialogs/ProductSelectTableDialog";
import Editor from "../../../components/editor/Editor";
import Table, { buttonsStyle } from "../../../components/tables/table";
import { useSkeleton } from "../../../hooks/useSkeleton";
import ProductContent from "../products/ProductContent";
import { formatInstallationTime } from "../../../../utils/helpers";
import { getProductMarcas } from "../../../../api/productMarca";
import { getCustomers } from "../../../../api/customer";
import { getMaterialGroups } from "../../../../api/materialGroup";
import CreatePartidaSubcategoryDialog from "../../../components/dialogs/CreatePartidaSubcategoryDialog";
import { ROLES } from "../../../../utils/constants";
import MaterialGroupSelectDialog from "../../../components/dialogs/MaterialGroupSelectDialog";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyPartida() {
  return {
    referencia: null,
    descripcion: null,
    categoria_id: null,
    categoria_ids: [],
    cliente_id: null,
    concepto: null,
    productos: [],
    agrupaciones_materiales: [],
  };
}

// function getProductData(partidaProducts, products) {
//   let data = [];

//   for (let i = 0; i < partidaProducts.length; ++i) {
//     const elem = {};

//     const partidaProduct = partidaProducts[i];

//     const product = products.find((x) => x?.id === partidaProduct?.producto_id);

//     elem.tipoUnidad = product?.tipo_unidad?.descripcion;
//     elem.referencia = product?.referencia;
//     elem.descripcion = product?.descripcion;
//     elem.marca = product?.marca?.nombre;
//     elem.familia = product?.familia?.descripcion;
//     elem.tipoProducto = product?.tipo_producto?.descripcion;
//     elem.precio = product?.precio + " €";
//     elem.tiempo = formatInstallationTime(product?.tiempo_instalacion);
//     elem.unidades = partidaProduct?.unidades;
//     elem.id = product?.id;

//     data = data.concat(elem);
//   }
//   return data;
// }

function getProductData(partidaProducts = [], products = []) {
  return partidaProducts
    .filter((partidaProduct) => partidaProduct?.producto_id != null)
    .map((partidaProduct) => {
      const product = products.find(
        (x) => x?.id === partidaProduct?.producto_id
      );

      return {
        id: partidaProduct._rowId, // 👈 CLAVE
        producto_id: partidaProduct.producto_id,
        unidades: partidaProduct?.unidades ?? "",
        tipoUnidad: product?.tipo_unidad?.descripcion || "",
        referencia: product?.referencia || "",
        descripcion: product?.descripcion || "",
        marca: product?.marca?.nombre || "",
        familia: product?.familia?.descripcion || "",
        tipoProducto: product?.tipo_producto?.descripcion || "",
        precio: product?.precio != null ? `${product.precio} €` : "",
        tiempo: product ? formatInstallationTime(product?.tiempo_instalacion) : "",
      };
    });
}

export default function EditPartidasPage() {
  const [partida, setPartida] = useState(getEmptyPartida());

  const [categories, setCategories] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [productMarcas, setProductMarcas] = useState([]);
  const [productFamilies, setProductFamilies] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [productUnitTypes, setProductUnitTypes] = useState([]);
  const [materialGroups, setMaterialGroups] = useState([]);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openProductTableDialog, setOpenProductTableDialog] = useState(false);
  const [openMaterialGroupDialog, setOpenMaterialGroupDialog] = useState(false);
  const [openProductInfoDialog, setOpenProductInfoDialog] = useState(null);
  const [openCreateSubcategoryDialog, setOpenCreateSubcategoryDialog] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState(null);
  

  const [partidaId, setPartidaId] = useState(useParams().id);

  const history = useHistory();
  const location = useLocation();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );
  const isOfferManager = loggedUser?.role?.rango === ROLES.GESTOR_OFERTAS;

  const handleBack = () => {
    const prevTablePage = location.state?.page;

    history.push(`/partidas${prevTablePage ? "?page=" + prevTablePage : ""}`);
  };

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    getProductMarcas(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductMarcas(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las marcas de productos.",
        });
      });
    getProductFamilies(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductFamilies(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las familias de productos.",
        });
      });
    getProductTypes(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductTypes(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de productos.",
        });
      });
    getPartidaCategories(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setCategories(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las categorías.",
        });
        handleBack();
      });
    getCustomers(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setCustomers(
            (res.data || []).filter(
              (customer) => customer?.activo && customer?.usar_partidas_especificas
            )
          );
        }
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se han podido obtener los clientes disponibles.",
        });
      });
    getProductUnitTypes(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductUnitTypes(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de unidades.",
        });
      });
    getProducts(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProducts(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los productos.",
        });
        handleBack();
      });
    getMaterialGroups(loggedUser?.accessToken).then((res) => setMaterialGroups(res.data)).catch(() => {});
    if (!partidaId) {
      const defaultCategoryIds = [
        location.state?.defaultCategoryId,
        location.state?.defaultSubcategoryId,
      ].filter(Boolean);
      if (defaultCategoryIds.length) {
        setPartida((current) => ({
          ...current,
          categoria_id: defaultCategoryIds[0],
          categoria_ids: defaultCategoryIds,
        }));
      }
      disableLoadingData();
      return;
    }
    getPartidaById(partidaId, loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setPartida({
            ...res.data,
            categoria_id: res.data?.categoria?.id,
            categoria_ids: res.data?.categoria_ids || [res.data?.categoria?.id].filter(Boolean),
            productos: res.data?.productos?.map((x) => ({
            _rowId: uuid(), // 👈 CLAVE
            producto_id: x?.producto?.id,
            unidades: x?.unidades,
          })),
            agrupaciones_materiales: res.data?.agrupaciones_materiales || [],
          });
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la partida.",
        });
        handleBack();
      });
  }, [partidaId]);



  function savePartida() {
    const validatePartida = () => {
      let error = "";

      if (!partida?.descripcion) {
        error = "La descripción es obligatoria.";
      } else if (!partida?.referencia) {
        error = "La referencia es obligatoria.";
      } else if (partida.referencia.length > PARTIDA_REFERENCE_MAX_LENGTH) {
        error = `La referencia no puede superar los ${PARTIDA_REFERENCE_MAX_LENGTH} caracteres.`;
      } else if (!partida?.categoria_ids?.length) {
        error = "Debe seleccionar al menos una categoría.";
      } else if (!partida?.concepto) {
        error = "El concepto es obligatorio.";
      } else if (partida?.productos?.some((x) => !x.unidades)) {
        error = "Todos los productos deben tener unidades.";
      }

      if (error) {
        alertError({
          error: error,
        });
        return false;
      }

      return true;
    };

    if (!validatePartida()) {
      return;
    }

    if (!partidaId) {
      postPartida(partida, loggedUser?.accessToken)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "¡Guardada!",
              customMessage: "Partida guardada con éxito.",
            });
            const newPartidaId = res.data?.id;
            getPartidaById(newPartidaId, loggedUser?.accessToken)
              .then((res) => {
                if (res.status === 200) {
                  setPartida({
                    ...res.data,
                    categoria_id: res.data?.categoria?.id,
                    categoria_ids: res.data?.categoria_ids || [res.data?.categoria?.id].filter(Boolean),
                    productos: res.data?.productos?.map((x) => ({
                      _rowId: uuid(),
  producto_id: x?.producto?.id,
  unidades: x?.unidades,
                    })),
                    agrupaciones_materiales: res.data?.agrupaciones_materiales || [],
                  });
                  setPartidaId(newPartidaId);
                }
              })
              .catch((error) => {});
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guardar la partida.",
          });
        });
    } else {
      updatePartida(partidaId, partida, loggedUser?.accessToken)
        .then((res) => {
          if (res.status === 204) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Cambios guardados con éxito.",
            });
            getPartidaById(partidaId, loggedUser?.accessToken)
              .then((res) => {
                if (res.status === 200) {
                  setPartida({
                    ...res.data,
                    categoria_id: res.data?.categoria?.id,
                    categoria_ids: res.data?.categoria_ids || [res.data?.categoria?.id].filter(Boolean),
                    productos: res.data?.productos?.map((x) => ({
                      _rowId: uuid(),
  producto_id: x?.producto?.id,
  unidades: x?.unidades,
                    })),
                    agrupaciones_materiales: res.data?.agrupaciones_materiales || [],
                  });
                }
              })
              .catch((error) => {});
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setPartida({ ...partida, [element]: event.target.value });
  };

  const handleChangeEditor = (element, value) => {
    if (value?.trim() !== "") {
      setPartida({ ...partida, [element]: value });
    }
  };

function buttonFormatter(rowId) {
  return (
    <Button
      style={buttonsStyle}
      size="small"
      onClick={(e) => {
        e.stopPropagation();

        setPartida((prev) => ({
          ...prev,
          productos: (prev.productos || []).filter(
            (x) => x._rowId !== rowId
          ),
        }));
      }}
    >
      <Delete />
    </Button>
  );
}

  function unidadesFormatter(rowId) {
  const partidaProduct = partida?.productos?.find((x) => x._rowId === rowId);

  return (
    <input
      style={{ width: "100%" }}
      type="number"
      min={0}
      value={partidaProduct?.unidades ?? 0}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        const value = Number(e.target.value);

        setPartida((prev) => ({
          ...prev,
          productos: (prev.productos || []).map((product) =>
            product._rowId === rowId
              ? { ...product, unidades: value }
              : product
          ),
        }));
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.target.blur();
      }}
    />
  );
}

  const columns = [
  { dataField: "tipoUnidad", text: "Tipo Unidad", sort: true },
  {
    dataField: "referencia",
    text: "Referencia",
    sort: true,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "descripcion",
    text: "Descripción",
    sort: true,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "marca",
    text: "Marca",
    sort: true,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "familia",
    text: "Família",
    sort: true,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "tipoProducto",
    text: "Tipo",
    sort: true,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "precio",
    text: "Precio",
    sort: true,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "tiempo",
    text: "Tiempo",
    sort: true,
    headerAlign: "center",
    align: "center",
  },
  {
    dataField: "unidades",
    text: "Unidades",
    sort: true,
    headerAlign: "center",
    align: "center",
    formatter: (cell, row) => unidadesFormatter(row.id),
  },
  {
    dataField: "acciones",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => buttonFormatter(row.id),
  },
  ].filter((column) => !isOfferManager || column.dataField !== "precio");

  const selectedCategoryIds = partida?.categoria_ids || [];
  const rootCategories = categories.filter((category) => !category.categoria_padre_id);
  const selectedRoots = rootCategories.filter((category) =>
    selectedCategoryIds.includes(category.id) || categories.some((child) =>
      child.categoria_padre_id === category.id && selectedCategoryIds.includes(child.id)
    )
  );
  const selectedSubcategories = categories.filter((category) =>
    category.categoria_padre_id && selectedCategoryIds.includes(category.id)
  );
  const availableSubcategories = categories.filter((category) =>
    category.categoria_padre_id && selectedRoots.some((root) => root.id === category.categoria_padre_id)
  );
  const setCategorySelection = (roots, subcategories) => {
    const ids = [...new Set([...roots.map((category) => category.id), ...subcategories.map((category) => category.id)])];
    setPartida({ ...partida, categoria_ids: ids, categoria_id: ids[0] || null });
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Partida">
            <CardHeaderToolbar>
              <Button
                onClick={() => savePartida()}
                variant="outlined"
                color="primary"
                style={{
                  marginRight: partidaId ? "20px" : "",
                }}
              >
                Guardar partida
              </Button>
              {partidaId && (
                <>
                  <MuiThemeProvider theme={theme}>
                    <Button
                      className="py-2"
                      onClick={() => setOpenConfirmDialog(true)}
                      variant="outlined"
                      color="secondary"
                    >
                      Eliminar partida
                    </Button>
                  </MuiThemeProvider>
                </>
              )}
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <TextField
                  fullWidth
                  id={`descripcion`}
                  label="Descripción"
                  value={partida.descripcion}
                  onChange={handleChange("descripcion")}
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <TextField
                  fullWidth
                  id={`referencia`}
                  label="Referencia"
                  value={partida.referencia}
                  onChange={handleChange("referencia")}
                  error={(partida?.referencia?.length || 0) > PARTIDA_REFERENCE_MAX_LENGTH}
                  helperText={
                    (partida?.referencia?.length || 0) > PARTIDA_REFERENCE_MAX_LENGTH
                      ? `Máximo ${PARTIDA_REFERENCE_MAX_LENGTH} caracteres.`
                      : ""
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <TextField
                  select
                  fullWidth
                  label="Cliente"
                  value={partida.cliente_id || ""}
                  SelectProps={{
                    displayEmpty: true,
                    renderValue: (value) => {
                      if (!value) return "General";
                      return customers.find((customer) => customer.id === value)?.nombre || "General";
                    },
                  }}
                  onChange={(event) =>
                    setPartida({
                      ...partida,
                      cliente_id: event.target.value || null,
                    })
                  }
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  variant="outlined"
                >
                  <MenuItem value="">General</MenuItem>
                  {customers.map((customer) => (
                    <MenuItem key={customer.id} value={customer.id}>
                      {customer.nombre}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
            <div className="row d-flex align-items-center">
              <div className="col-md-6">
                <Autocomplete
                  id="autocomplete-categorias-raiz"
                  multiple
                  filterSelectedOptions
                  options={rootCategories}
                  getOptionLabel={(option) => option?.descripcion || ""}
                  value={selectedRoots}
                  onChange={(event, selected) => {
                    setCategorySelection(
                      selected,
                      selectedSubcategories.filter((subcategory) => selected.some((root) => root.id === subcategory.categoria_padre_id))
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Categorías"
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                    />
                  )}
                />
              </div>
              <div className="col-md-6 d-flex align-items-center">
                <Autocomplete
                  className="w-100"
                  id="autocomplete-subcategorias"
                  multiple
                  disabled={!selectedRoots.length}
                  filterSelectedOptions
                  options={availableSubcategories}
                  getOptionLabel={(option) => option?.descripcion || ""}
                  value={selectedSubcategories}
                  onChange={(event, selected) => setCategorySelection(selectedRoots, selected)}
                  renderInput={(params) => (
                    <TextField {...params} label="Subcategorías" margin="normal" variant="outlined" InputLabelProps={{ shrink: true }} />
                  )}
                />
                <Button
                  className="align-self-center ml-2"
                  style={{ whiteSpace: "nowrap", flexShrink: 0 }}
                  variant="outlined"
                  color="primary"
                  disabled={selectedRoots.length !== 1}
                  onClick={() => setOpenCreateSubcategoryDialog(true)}
                >
                  Nueva subcategoría
                </Button>
              </div>
            </div>

            <br />
            <div>Concepto *</div>
            <br />
            <Editor
              body={partida?.concepto || ""}
              setBody={(new_body) => {
                handleChangeEditor("concepto", new_body);
              }}
              className="max-height"
              placeholder={"Introduce el concepto aquí..."}
            />
          </CardBody>
          <CardHeader title="Descompuesto" sticky={false}>
            <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setOpenProductTableDialog(true);
                }}
              >
                Añadir productos
              </button>
              <button type="button" className="btn btn-light-primary ml-2" onClick={() => setOpenMaterialGroupDialog(true)}>Añadir agrupación</button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            {/* {partida.productos?.length > 0 ? (
              <>
                {!refresh && (
                  <Table
                    data={getProductData(partida.productos, products)}
                    columns={columns}
                    rowEvents={{
                      onClick: (e, row, rowIndex) => {
                        const product = products?.find((x) => x.id === row.id);
                        setSelectedProduct(product);
                        setOpenProductInfoDialog(true);
                      },
                    }}
                  />
                )}
              </>
            ) : (
              <div>Añada productos para gestionar el descompuesto</div>
            )} */}
            {partida.productos?.length > 0 ? (
            <>
              {products?.length > 0 && (
                <Table
                  data={getProductData(partida.productos, products)}
                  columns={columns}
                  rowEvents={{
  onClick: (e, row) => {
    if (!row?.producto_id) return;

    const product = products?.find((x) => x.id === row.producto_id);
    if (!product) return;

    setSelectedProduct(product);
    setOpenProductInfoDialog(true);
  },
}}
                />
              )}

              {products?.length === 0 && (
                <div>Cargando productos...</div>
              )}
            </>
          ) : (
            <div>Añada productos para gestionar el descompuesto</div>
          )}
          </CardBody>
          {(partida.agrupaciones_materiales || []).map((group) => (
            <div key={group.id || group.agrupacion_material_original_id} className="mx-5 mb-3 p-3" style={{ background: "#eef7ff", borderLeft: "4px solid #3699ff" }}>
              <div className="d-flex justify-content-between"><strong>Agrupación: {group.descripcion}</strong><Button color="secondary" size="small" onClick={() => setPartida((current) => ({ ...current, agrupaciones_materiales: current.agrupaciones_materiales.filter((x) => x !== group) }))}>Eliminar</Button></div>
              <div className="text-muted d-flex align-items-center">Cantidad por partida: <TextField type="number" value={group.unidades} inputProps={{ min: 0.01, step: 0.01 }} style={{ width: "90px", marginLeft: "8px" }} onChange={(event) => setPartida((current) => ({ ...current, agrupaciones_materiales: current.agrupaciones_materiales.map((item) => item === group ? { ...item, unidades: Number(event.target.value) } : item) }))} /> <span className="ml-2">{group.tipo_unidad?.descripcion || "ud."}</span></div>
              {(group.productos || []).map((line) => <div key={line.producto_id} className="pl-3">• {line.producto?.descripcion} × {line.unidades}</div>)}
            </div>
          ))}
        </Card>
        <Button
          onClick={handleBack}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Atrás
        </Button>
        <Button
          onClick={() => savePartida()}
          variant="outlined"
          color="primary"
          style={{ marginRight: partidaId ? "20px" : "" }}
        >
          Guardar partida
        </Button>
        {partidaId && (
          <>
            <MuiThemeProvider theme={theme}>
              <Button
                className="py-2"
                onClick={() => setOpenConfirmDialog(true)}
                variant="outlined"
                color="secondary"
              >
                Eliminar partida
              </Button>
            </MuiThemeProvider>

            <ConfirmDialog
              title={"¿Estás seguro de que quieres eliminar esta partida?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deletePartida(partidaId, loggedUser?.accessToken)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      alertSuccess({
                        title: "¡Eliminada!",
                        customMessage: "Partida eliminada con éxito",
                      });
                      handleBack();
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "No se ha podido eliminar la partida.",
                    });
                  });
              }}
            />
          </>
        )}
        <ProductSelectTableDialog
          title="Productos"
          open={openProductTableDialog}
          setOpen={setOpenProductTableDialog}
          data={products?.filter(
            (x) =>
              ![...partida.productos]?.some((y) => y?.producto_id === x?.id)
          )}
          productMarcas={productMarcas}
          productFamilies={productFamilies}
          productTypes={productTypes}
          productUnitTypes={productUnitTypes}
          initialSelectedProducts={[...partida.productos]?.map(
            (x) => x?.producto_id
          )}
          onSave={(selectedProductIds) => {
  const ids = Array.isArray(selectedProductIds)
    ? selectedProductIds
    : [selectedProductIds];

  setPartida((prev) => {
    const nextProducts = [...(prev.productos || [])];

    ids.forEach((productId) => {
      if (productId == null) return;

      const exists = nextProducts.some(
        (x) => x.producto_id === productId
      );

      if (!exists) {
        nextProducts.push({
          _rowId: uuid(),
          producto_id: productId,
          unidades: 1,
        });
      }
    });

    return {
      ...prev,
      productos: nextProducts,
    };
  });

  if (ids.some((id) => !products?.some((x) => x.id === id))) {
    getProducts(loggedUser?.accessToken)
      .then((res) => {
        setProducts(res.data);
      })
      .catch(() => {});
  }
}}
        />
        <MaterialGroupSelectDialog open={openMaterialGroupDialog} setOpen={setOpenMaterialGroupDialog} data={materialGroups} onSave={(ids) => setPartida((current) => ({ ...current, agrupaciones_materiales: [...(current.agrupaciones_materiales || []), ...ids.filter((id) => !(current.agrupaciones_materiales || []).some((x) => x.agrupacion_material_original_id === id)).map((id, index) => { const group = materialGroups.find((x) => x.id === id); return { agrupacion_material_original_id: group.id, referencia: group.referencia, descripcion: group.descripcion, tipo_unidad_id: group.tipo_unidad_id, tipo_unidad: group.tipo_unidad, unidades: 1, ordinal: (current.agrupaciones_materiales || []).length + index, productos: (group.productos || []).map((line) => ({ producto_id: line.producto_id, unidades: line.unidades, ordinal: line.ordinal, producto: line.producto })) }; })] }))} />
        <EntityInfoDialog
          title={"Producto: " + selectedProduct?.descripcion}
          open={openProductInfoDialog}
          setOpen={setOpenProductInfoDialog}
          content={<ProductContent product={selectedProduct} />}
        />
        <CreatePartidaSubcategoryDialog
          open={openCreateSubcategoryDialog}
          setOpen={setOpenCreateSubcategoryDialog}
          parentCategory={selectedRoots.length === 1 ? selectedRoots[0] : null}
          onCreated={(subcategory) => {
            setCategories((current) => [...current, subcategory]);
            setCategorySelection(selectedRoots, [...selectedSubcategories, subcategory]);
          }}
        />
      </>
    );
}
